import { createFeatureSelector, createSelector } from '@ngrx/store'
import { INonCadastralContractCreateState } from './non-cadastral-contract-create.reducer'
import { StoreKeysEnum } from '../../../../../store/store-keys'
import { toDisplayUnits } from '../../../../../shared/utils/month-year-unit'

export const selectNonCadastralContractCreateFeature = createFeatureSelector<Readonly<INonCadastralContractCreateState>>(StoreKeysEnum.NonCadastralContractCreateComponent)

export const selectNonCadastralContractCreateContract = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.contract),
)
export const selectNonCadastralContractCreateContractOwnersLength = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.owners?.length),
)
export const selectNonCadastralContractCreateEditedCPD = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.editedCPD),
)
export const selectNonCadastralContractCreateEditedOwnerships = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.editedOwnerships),
)
export const selectNonCadastralContractCreateEditedParcel = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.editedParcel),
)
export const selectNonCadastralContractCreateIndividual = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.individual),
)
export const selectNonCadastralContractCreateOwners = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.owners),
)
export const selectNonCadastralContractCreateOwnersLength = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature.owners?.length),
)
export const selectNonCadastralContractCreateTenants = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.tenants),
)
export const selectNonCadastralContractCreateContractId = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.id),
)

export const selectNonCadastralContractCreatePayoutTo = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.payoutTo),
)
export const selectNonCadastralContractCreatePayoutToId = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.payoutToId),
)
export const selectNonCadastralContractCreateContractCreateIndividualDocuments = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.createIndividualDocuments),
)
export const selectNonCadastralContractCreateExpirationDate = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.expirationDate),
)
export const selectNonCadastralContractSuccessiveSourceContractNumber = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.successiveSourceContractNumber),
)
export const selectNonCadastralContractCreateDrupozs = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.drupozs),
)
export const selectNonCadastralContractCreateZpvypos = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.zpvypos),
)
export const selectNonCadastralContractCreateParcels = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.parcels),
)
export const selectNonCadastralContractCreateContractParamTemplates = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.contractParamTemplates),
)
export const selectNonCadastralContractCreateContractRentDrupozCollection = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.contractRentDrupozCollection),
)
export const selectNonCadastralContractCreateContractRentUnknownCollection = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.contractRentUnknownCollection),
)
export const selectNonCadastralContractCreateSelectedContractTemplate = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.selectedContractTemplate),
)
export const selectNonCadastralContractCreateCounterpartyNumber = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.counterpartyNumber),
)
export const selectNonCadastralContractCreateContractPaymentsFromEconomicYear = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.contract?.paymentsFromEconomicYear),
)
export const selectNonCadastralContractCreateFirstPossibleTerminationDate = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.firstPossibleTerminationDate),
)
export const selectNonCadastralContractCreateIsEdit = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.isEdit),
)
export const selectNonCadastralContractCreateIsRentTypeDefined = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.isRentTypeDefined),
)
export const selectNonCadastralContractCreateIsEditingContract = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.isEditingContract),
)
export const selectNonCadastralContractCreateIsLoading = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.isLoading),
)
export const selectNonCadastralContractIsFormActive = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.isFormActive),
)
export const selectNonCadastralContractCreateRunningTask = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => feature?.runningTask,
)
export const selectNonCadastralContractCreateSelectedTab = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.selectedTab),
)
export const selectNonCadastralContractCreateSignatureYear = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.signatureYear),
)
export const selectNonCadastralContractCreateTotalAcreage = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.totalAcreage),
)
export const selectNonCadastralContractCreateParcelsOrder = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.parcelsOrder),
)
export const selectNonCadastralContractCreateContractNote = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.note),
)
export const selectNonCadastralContractCreateContractOwnerIds = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.ownerIds),
)
export const selectNonCadastralContractCreateContractTenantIds = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.tenantIds),
)
export const selectNonCadastralContractCreateContractParcelIds = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.parcelIds),
)
export const selectNonCadastralContractCreateContractCpds = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.cpds),
)
export const selectNonCadastralContractCreateDurationPeriodState = createSelector(
    selectNonCadastralContractCreateContract,
    (contract) => ({
        indefinite: contract?.indefinite,
        reusedPreviousExpiration: contract?.reusedPreviousExpiration,
        durationMonths: toDisplayUnits(contract?.durationMonths, contract?.durationMonthsUnit),
        durationMonthsUnit: contract?.durationMonthsUnit,
        durationToDate: contract?.durationToDate,
    }),
)
export const selectNonCadastralContractCreateNoticePeriod = createSelector(
    selectNonCadastralContractCreateContract,
    (contract) => ({
        noticePeriodMonths: toDisplayUnits(contract?.noticePeriodMonths, contract?.noticePeriodMonthsUnit),
        noticePeriodMonthsUnit: contract?.noticePeriodMonthsUnit,
        indefinite: contract?.indefinite,
    }),
)

export const selectNonCadastralContractCreateContractSignatureDate = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.signatureDate),
)
export const selectNonCadastralContractCreateContractToEconomicYear = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.toEconomicYear),
)
export const selectNonCadastralContractCreateContractOwnerParams = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.ownerparams),
)
export const selectNonCadastralContractCreateContractFurtherRentPossible = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.furtherRentPossible),
)
export const selectNonCadastralContractCreateContractReqNewAppendixAfterReprice = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.reqNewAppendixAfterReprice),
)
export const selectNonCadastralContractCreateContractTenantHasPreemption = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.tenantHasPreemption),
)
export const selectNonCadastralContractCreateContractContractParamTemplate = createSelector(
    selectNonCadastralContractCreateContract,
    contract => (contract?.contractParamTemplate),
)
export const selectNonCadastralContractCreateAttachments = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.attachments),
)
export const selectNonCadastralContractCreateAttachmentsLoading = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.attachmentsLoading),
)
export const selectNonCadastralContractCreateParamTemplates = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.contractParamTemplates),
)
export const selectNonCadastralContractCreateAttachmentsState = createSelector(
    selectNonCadastralContractCreateAttachments,
    selectNonCadastralContractCreateAttachmentsLoading,
    (attachments, attachmentsLoading) => ({
        attachments,
        attachmentsLoading,
    }),
)
export const selectNonCadastralContractCreateSameLVAndKatuze = createSelector(
    selectNonCadastralContractCreateFeature,
    feature => (feature?.sameLVAndKatuze),
)
export const selectNonCadastralContractCreateState = createSelector(
    selectNonCadastralContractCreateSameLVAndKatuze,
    (sameLVAndKatuze) => ({
        allowEdit: true,
        isAppendix: false,
        relatedContracts: [],
        sameLVAndKatuze,
        signatureDocuments: [],
        successiveContractAvailable: false,
    }),
)

export const selectNonCadastralContractCreateLvInfo = createSelector(
    selectNonCadastralContractCreateParcels,
    selectNonCadastralContractCreateSameLVAndKatuze,
    (parcels, sameLVAndKatuze) => {
        if (sameLVAndKatuze && parcels?.length) {
            return parcels[0].katuzeNazev + ', LV ' + parcels[0].lv
        } else {
            return null
        }
    },
)
export const selectNonCadastralContractCreateParcelRentedAcreage = createSelector(
    selectNonCadastralContractCreateEditedParcel,
    selectNonCadastralContractCreateTenants,
    selectNonCadastralContractCreateEditedCPD,
    (editedParcel, tenants, editedCpd) => ({
        editedParcel,
        tenants,
        editedCpd,
    }),
)
export const selectNonCadastralContractCreateTaxTenant = createSelector(
    selectNonCadastralContractCreateDrupozs,
    selectNonCadastralContractCreateEditedParcel,
    selectNonCadastralContractCreateEditedCPD,
    (drupozs, editedParcel, editedCpd) => ({
        drupozs,
        editedParcel,
        editedCpd,
    }),
)
export const selectNonCadastralContractCreateAddToAttachment = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateOwners,
    selectNonCadastralContractCreateIndividual,
    (contract, owners, individual) => ({
        contract,
        owners,
        individualDocumentNote: individual?.documentNote,
        documentNote: contract?.documentNote,
    }),
)
export const selectNonCadastralContractCreateContractOptionalParagraph = createSelector(
    selectNonCadastralContractCreateContractFurtherRentPossible,
    selectNonCadastralContractCreateContractReqNewAppendixAfterReprice,
    selectNonCadastralContractCreateContractTenantHasPreemption,
    (furtherRentPossible, reqNewAppendixAfterReprice, tenantHasPreemption) => ({
        furtherRentPossible,
        reqNewAppendixAfterReprice,
        tenantHasPreemption,
    }),
)
export const selectNonCadastralContractCreateTemplates = createSelector(
    selectNonCadastralContractCreateContractContractParamTemplate,
    selectNonCadastralContractCreateParamTemplates,
    selectNonCadastralContractCreateIsLoading,
    (contractParamTemplate, contractParamTemplates, contractIsLoading) => ({
        contractParamTemplate,
        contractParamTemplates,
        contractIsLoading,
    }),
)
export const selectNonCadastralContractCreateWatch = createSelector(
    selectNonCadastralContractCreateContract,
    (contract) => ({
        isWatched: contract?.isWatched,
        watchReason: contract?.watchReason,
    }),
)
export const selectNonCadastralContractCreateBooleans = createSelector(
    selectNonCadastralContractCreateIsLoading,
    selectNonCadastralContractCreateIsEdit,
    selectNonCadastralContractCreateIsRentTypeDefined,
    selectNonCadastralContractCreateIsEditingContract,
    selectNonCadastralContractCreateSameLVAndKatuze,
    (isLoading, isEdit, isRentTypeDefined, isEditingContract, sameLVAndKatuze) => ({
        isLoading,
        isEdit,
        isRentTypeDefined,
        isEditingContract,
        sameLVAndKatuze,
    }),
)
export const selectNonCadastralContractCreateEditedObjects = createSelector(
    selectNonCadastralContractCreateEditedCPD,
    selectNonCadastralContractCreateEditedOwnerships,
    selectNonCadastralContractCreateEditedParcel,
    (editedCPD, editedOwnerships, editedParcel) => ({
        editedCPD,
        editedOwnerships,
        editedParcel,
    }),
)
export const selectNonCadastralContractCreateObjects = createSelector(
    selectNonCadastralContractCreateParcels,
    selectNonCadastralContractCreateOwners,
    selectNonCadastralContractCreateTenants,
    selectNonCadastralContractCreateContractParamTemplates,
    selectNonCadastralContractCreateContractRentDrupozCollection,
    selectNonCadastralContractCreateContractRentUnknownCollection,
    selectNonCadastralContractCreateDrupozs,
    (parcels, owners, tenants, contractParamTemplates, contractRentDrupozCollection, contractRentUnknownCollection, drupozs) => ({
        parcels,
        owners,
        tenants,
        contractParamTemplates,
        contractRentDrupozCollection,
        contractRentUnknownCollection,
        drupozs,
    }),
)
export const selectNonCadastralContractCreateData = createSelector(
    selectNonCadastralContractCreateFirstPossibleTerminationDate,
    selectNonCadastralContractCreateIndividual,
    selectNonCadastralContractCreateRunningTask,
    selectNonCadastralContractCreateSelectedTab,
    selectNonCadastralContractCreateSelectedContractTemplate,
    selectNonCadastralContractCreateSignatureYear,
    selectNonCadastralContractCreateTotalAcreage,
    selectNonCadastralContractCreateParcelsOrder,
    (firstPossibleTerminationDate, individual, runningTask, selectedTab, selectedContractTemplate, signatureYear, totalAcreage, parcelsOrder) => ({
        firstPossibleTerminationDate,
        individual,
        runningTask,
        selectedTab,
        selectedContractTemplate,
        signatureYear,
        totalAcreage,
        parcelsOrder,
    }),
)
export const selectNonCadastralContractCreateParcelRentData = createSelector(
    selectNonCadastralContractCreateEditedCPD,
    selectNonCadastralContractCreateEditedParcel,
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateContractRentDrupozCollection,
    selectNonCadastralContractCreateContractRentUnknownCollection,
    (editedCPD, editedParcel, contract, contractRentDrupozCollection, contractRentUnknownCollection) => ({
        editedCPD,
        editedParcel,
        contract,
        contractRentDrupozCollection,
        contractRentUnknownCollection,
    }),
)
export const selectNonCadastralContractCreateComputePriceAndTax = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateContractRentDrupozCollection,
    selectNonCadastralContractCreateContractRentUnknownCollection,
    (contract, contractRentDrupozCollection, contractRentUnknownCollection) => ({
        contract,
        contractRentDrupozCollection,
        contractRentUnknownCollection,
    }),
)
export const selectNonCadastralContractCreatePrepareParcels = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateDrupozs,
    selectNonCadastralContractCreateZpvypos,
    selectNonCadastralContractCreateOwners,
    (contract, drupozs, zpvypos, owners) => ({
        contract, drupozs, zpvypos, owners,
    }),
)
export const selectNonCadastralContractCreatePrepareOwners = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateTenants,
    (contract, tenants) => ({
        contract, tenants,
    }),
)
export const selectNonCadastralContractCreatePrepareContract = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateContractParamTemplates,
    selectNonCadastralContractCreateSelectedContractTemplate,
    (contract, contractParamTemplates, selectedContractTemplate) => ({
        contract, contractParamTemplates, selectedContractTemplate,
    }),
)
export const selectNonCadastralContractCreateAddParcels = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateParcels,
    (contract, parcels) => ({
        contract, parcels,
    }),
)
export const selectNonCadastralContractCreateRemoveParcel = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateParcels,
    selectNonCadastralContractCreateEditedCPD,
    selectNonCadastralContractCreateEditedParcel,
    (contract, parcels, editedCPD, editedParcel) => ({
        contract, parcels, editedCPD, editedParcel,
    }),
)
export const selectNonCadastralContractCreateAddContractOwner = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateOwners,
    selectNonCadastralContractCreateTenants,
    selectNonCadastralContractCreateSelectedContractTemplate,
    (contract, owners, tenants, selectedContractTemplate) => ({
        contract, owners, tenants, selectedContractTemplate,
    }),
)
export const selectNonCadastralContractCreatePrepareContractParamTemplates = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateSelectedContractTemplate,
    (contract, selectedContractTemplate) => ({
        contract, selectedContractTemplate,
    }),
)
export const selectNonCadastralContractCreateSignatureDate = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateSignatureYear,
    (contract, signatureYear) => ({
        contract, signatureYear,
    }),
)
export const selectNonCadastralContractCreateContractParcelRent = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateContractRentDrupozCollection,
    selectNonCadastralContractCreateContractRentUnknownCollection,
    selectNonCadastralContractCreateEditedCPD,
    selectNonCadastralContractCreateEditedParcel,
    (contract, contractRentDrupozCollection, contractRentUnknownCollection, editedCPD, editedParcel) => ({
        contract, contractRentDrupozCollection, contractRentUnknownCollection, editedCPD, editedParcel,
    }),
)
export const selectNonCadastralContractCreateEditedCpdConsequencies = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateParcels,
    selectNonCadastralContractCreateEditedCPD,
    selectNonCadastralContractCreateEditedParcel,
    selectNonCadastralContractCreateContractCpds,
    (contract, parcels, editedCPD, editedParcel, cpds) => ({
        contract, parcels, editedCPD, editedParcel, cpds,
    }),
)
export const selectNonCadastralContractCreateCpdsUseParcelRent = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateEditedCPD,
    (contract, editedCPD) => ({
        contract, editedCPD,
    }),
)
export const selectNonCadastralContractCreateContractParcelPrice = createSelector(
    selectNonCadastralContractCreateContract,
    selectNonCadastralContractCreateEditedCPD,
    selectNonCadastralContractCreateEditedParcel,
    (contract, editedCPD, editedParcel) => ({
        contract, editedCPD, editedParcel,
    }),
)
export const selectNonCadastralContractCreateIds = createSelector(
    selectNonCadastralContractCreateContractOwnerIds,
    selectNonCadastralContractCreateContractTenantIds,
    selectNonCadastralContractCreateContractParcelIds,
    (ownerIds, tenantIds, parcelIds) => ({
        ownerIds,
        tenantIds,
        parcelIds,
    }),
)
export const selectNonCadastralContractCreateDocumentsState = createSelector(
    selectNonCadastralContractCreateOwners,
    selectNonCadastralContractCreateContractId,
    selectNonCadastralContractCreatePayoutToId,
    selectNonCadastralContractCreatePayoutTo,
    selectNonCadastralContractCreateContractCreateIndividualDocuments,
    selectNonCadastralContractCreateIsEdit,
    selectNonCadastralContractCreateAttachments,
    selectNonCadastralContractCreateAttachmentsLoading,
    (owners, contractId, payoutToId, payoutTo, createIndividualDocuments, canAddDocuments, attachments, attachmentsLoading) => ({
        relatedContracts: [],
        signatureDocuments: [],
        signatureDocumentsGroup: [],
        owners,
        contractId,
        payoutToId,
        payoutTo,
        groupId: null,
        createIndividualDocuments,
        canAddDocuments,
        attachments,
        attachmentsLoading,
    }),
)